var exports = {
  "a": "RulesetFormErrorFlashContainer__bH1QXB",
  "x": "RulesetFormErrorFlash__E-Gn7L",
};

module.exports = exports;
